import styled from 'styled-components';

export const RecipeGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
	gap: 16px;
	width: 100%;
`;

export const RecipeCard = styled.div<{ $selected?: boolean }>`
	background-color: ${({ theme }) => theme.gray[0]};
	border: 1px solid ${({ theme, $selected }) => ($selected ? theme.blue[500] : theme.gray[200])};
	border-radius: 8px;
	padding: 16px;
	transition: all 0.2s ease;
	display: flex;
	flex-direction: column;
	gap: 8px;

	&:hover {
		border-color: ${({ theme, $selected }) => ($selected ? theme.blue[500] : theme.gray[400])};
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	}
`;

export const RecipeHeader = styled.div`
	display: flex;
	align-items: baseline;
	gap: 8px;
`;

export const RecipeName = styled.div`
	font-size: 14px;
	font-weight: 600;
	color: ${({ theme }) => theme.gray[1000]};
`;

export const RecipeClassName = styled.div`
	font-size: 12px;
	color: ${({ theme }) => theme.gray[600]};
	font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono',
		'Courier New', monospace;
`;

export const RecipeDescription = styled.div`
	font-size: 12px;
	color: ${({ theme }) => theme.gray[600]};
	line-height: 1.4;
`;

export const RecipeProperties = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2px;
	margin-top: 4px;
`;

export const RecipeProperty = styled.div`
	font-size: 11px;
	color: ${({ theme }) => theme.gray[700]};
	font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono',
		'Courier New', monospace;
	line-height: 1.4;
`;

export const PropertyName = styled.span`
	color: ${({ theme }) => theme.blue[700]};
`;

export const PropertyValue = styled.span`
	color: ${({ theme }) => theme.gray[600]};
`;

export const DomainHeader = styled.h3`
	font-size: 16px;
	font-weight: 600;
	color: ${({ theme }) => theme.gray[900]};
	margin: 24px 0 12px 0;
	text-transform: capitalize;

	&:first-of-type {
		margin-top: 0;
	}
`;

export const SubSectionTitle = styled.h3`
	font-size: 18px;
	font-weight: 600;
	color: ${({ theme }) => theme.gray[900]};
	margin: 0 0 16px 0;
`;
